import { getText } from '../../../services/text/text-service';
import * as React from 'react';
import { Title } from '@gje/typography/lib';
import { resolvePaymentTerm } from '../../../services/calculation-data/calculation-data-service';
import { isIE, isIOS, isIPad13, isTablet } from 'react-device-detect';
import useMobile from '../../../hooks/useMobile';
import classNames from 'classnames';
import { numberWithSpaces } from '../../../utils/stringUtils';
import {
    isOkq8,
    isVillaagarna
} from '../../../services/partners/partnersService';

interface PricePanelProps {
    insurancePrice: any;
    paymentTerm: number;
    insuranceName: string;
    key?: string /* needed for re-rendering in macOS safari(currently checked only for car - so it is optional) */;
    plusPackageAdded?: boolean;
    plusPackagePrice?: number;
    plusPackageName?: string;
    tillagsAdded?: boolean;
    tillagsHyrbilAdded?: boolean;
    tillagsHyrbilPrice?: number;
    tillagsAllriskAdded?: boolean;
    tillagsAllriskPrice?: number;
    tillagsName?: string;
    pricePanelMarginBottom?: boolean;
}

const PricePanel: React.FunctionComponent<PricePanelProps> = ({
    insurancePrice,
    paymentTerm,
    insuranceName,
    plusPackageAdded,
    plusPackagePrice,
    plusPackageName = getText('webshopsweden.common.plusPackage'),
    tillagsAdded,
    tillagsHyrbilAdded,
    tillagsHyrbilPrice,
    tillagsAllriskAdded,
    tillagsAllriskPrice,
    tillagsName = getText('webshopsweden.common.tillagsShortName'),
    pricePanelMarginBottom
}) => {
    const isMobile = useMobile();

    const priceToHigh = typeof insurancePrice == 'string';

    const isInsuranceName = insuranceName !== '';

    const priceWithPlusPackage = priceToHigh
        ? insurancePrice
        : (insurancePrice + plusPackagePrice).toString();

    const tillagsPrice =
        (tillagsHyrbilAdded ? tillagsHyrbilPrice : 0) +
        (tillagsAllriskAdded ? tillagsAllriskPrice : 0);

    const priceWithTillags = priceToHigh
        ? insurancePrice
        : (insurancePrice + tillagsPrice).toString();

    const textSizeChooser = () => {
        if (isMobile) {
            if (priceToHigh) {
                return 'h4';
            } else return 'h3';
        } else {
            if (priceToHigh) {
                return 'h3';
            } else return 'h2';
        }
    };

    return (
        <div
            id="scroll-trigger-out"
            className={classNames(
                'price-tag sticky-bar-bottom sticky-bar-visible ',
                !isIE
                    ? pricePanelMarginBottom
                        ? 'margin-bottom-39'
                        : 'negative-margin-bottom-39'
                    : 'container',
                { 'iphone-sticky-bar': isIOS },
                { 'villaagarna-orange-bg-color': isVillaagarna() },
                { 'okq8-blue-bg-color okq8-font': isOkq8() }
            )}>
            <div className={'row h-100'}>
                <div
                    className={
                        isMobile && !(isTablet || isIPad13) ? '' : 'col-sm-1-5'
                    }
                />
                <div
                    className={classNames(
                        'display-flex align-items h-100',
                        isMobile && !(isTablet || isIPad13)
                            ? 'col-sm-23'
                            : 'col-sm-20'
                    )}>
                    <Title
                        tag={textSizeChooser()}
                        className={classNames(
                            'line-height-1-1 padding-left-4',
                            {
                                'okq8-font-bold': isOkq8()
                            }
                        )}>
                        {priceToHigh
                            ? ''
                            : `${getText('webshopsweden.common.yourPrice')} `}

                        {plusPackageAdded
                            ? numberWithSpaces(Number(priceWithPlusPackage))
                            : tillagsAdded
                            ? numberWithSpaces(Number(priceWithTillags))
                            : typeof insurancePrice === 'string'
                            ? insurancePrice
                            : numberWithSpaces(Number(insurancePrice))}
                        {` ${resolvePaymentTerm(paymentTerm, insurancePrice)}`}
                        {!priceToHigh && isInsuranceName ? ' - ' : ''}
                        {isMobile && !(isTablet || isIPad13) ? <br /> : null}
                        <span
                            className={classNames({
                                'title-without-bold': !isOkq8(),
                                'okq8-font-bold': isOkq8()
                            })}>
                            {!priceToHigh ? insuranceName : ''}
                            {plusPackageAdded &&
                                !priceToHigh &&
                                ' & ' + plusPackageName}
                            {tillagsAdded &&
                                !priceToHigh &&
                                ' & ' + tillagsName}
                        </span>
                    </Title>
                </div>
                <div
                    className={
                        isMobile && !(isTablet || isIPad13) ? '' : 'col-sm-1-5'
                    }
                />
            </div>
        </div>
    );
};

export default PricePanel;
